import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, TextArea, Modal } from 'antd-mobile-v5';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_heart from '../../static/images_ae/reporting/organ_heart.png';
import organ_lung from '../../static/images_ae/reporting/organ_lung.png';
import blue_body from '../../static/images_ae/alkReport/blue_body.png';
import arrow_back from '../../static/images_ae/alkReport/arrow_back.png';
import organ_heart_blue from '../../static/images_ae/alkReport/organ_heart_blue.png';
import organ_heart_purple from '../../static/images_ae/alkReport/organ_heart_purple.png';
import organ_lung_blue from '../../static/images_ae/alkReport/organ_lung_blue.png';
import organ_lung_purple from '../../static/images_ae/alkReport/organ_lung_purple.png';
import line_to_heart from '../../static/images_ae/alkReport/line_to_heart.png';
import line_to_lung from '../../static/images_ae/alkReport/line_to_lung.png';
import body_organ_heart from '../../static/images_ae/alkReport/body_organ_heart.png';
import body_organ_lung from '../../static/images_ae/alkReport/body_organ_lung.png';
import { withRouter } from 'react-router-dom';
import styles from './chest.module.scss';

const api = new ApiCore();

const organMap = {
    'lung': '肺部',
    'heart': '心脏'
}

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [headSelected, setHeadSelected] = useState<any>(true);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>([]);
    const [activeOrgan, setActiveOrgan] = useState<any>('lung');
    const [brainIntro, setBrainIntro] = useState<any>('');
    const [eyeIntro, setEyeIntro] = useState<any>('');
    const [value, setValue] = useState<any>('');
    const [visible, setVisible] = useState<any>(false);
    const [lungSelectedCount, setLungSelectedCount] = useState<any>(0);
    const [heartSelectedCount, setHeartSelectedCount] = useState<any>(0);

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
    }, [])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
            if (val) {
                _selectedCount++;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    const initData = () => {
        let _organs = props.organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            if (vvv.type === 'lung') {
                setBrainIntro(vvv.remark);
            } else if (vvv.type === 'heart') {
                setEyeIntro(vvv.remark);
            }
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                return vvv;
            } else {
                const symptoms = vvv.symptoms.concat({
                    code: '',
                    name: '其他',
                    organCode: vvv.code
                })
                return {
                    ...vvv,
                    symptoms
                }
            }

        })
        setOrgans(_organs);
        let _list = organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        // 还原选中状态
        setOrganSelectedActive(_list);
    }

    const headSelect = () => {
        setHeadSelected(true);
        setChestSelected(false);
        setActiveOrgan('lung');
        // setActiveOrgan('heart');
        // const item = organList.filter((item: any) => item.type === 'heart');
        // setSymptoms(item);
    }

    const chestSelect = () => {
        // const item = organList.filter((item: any) => item.type === 'lung');
        // setSymptoms(item);
        
        // setChestSelected(!chestSelected);
        // setHeadSelected(false);
        setHeadSelected(false);
        setChestSelected(true);
        setActiveOrgan('heart');
    }

    const stomachSelect = () => {
        setStomachSelect(!stomachSelected);
    }

    const othersSelect = () => {
        setOthersSelected(!othersSelected);
    }

    const fourLimbsSelect = () => {
        setFourLimbsSelected(!fourLimbsSelected);
    }

    const symptomsSelected = (val: any, key: number) => {
        if (!val.code) {
            // 其他选项输入
            organList.some((val: any, key: number) => {
                if (activeOrgan === val.type) {
                    const _lastItem = val.symptoms[val.symptoms.length -1] || {};
                    if (_lastItem && _lastItem.code === '') {
                        setValue(_lastItem.value || '');
                        return true;
                    }
                }
            })
            setVisible(true);
            return;
        }
        let _lungCount = 0;
        let _heartCount = 0;
        const _list = organList.map((item: any) => {
            let _symptoms: any = item.symptoms.map((v: any) => {
                let _selected = !!v.selected;
                if (val.code === v.code) {
                    _selected = !v.selected;
                }
                if (item.type === 'lung') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _lungCount++;
                    }
                } else if (item.type === 'heart') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _heartCount++;
                    }
                }
                return {
                    ...v,
                    selected: _selected
                }
            });
            return {
                ...item,
                symptoms: _symptoms
            }
            // let selected = !!item.selected;
            // if (val.code === item.code) {
            //     selected = true;
            // }
            // return {
            //     selected: selected,
            //     ...item
            // }
        });
        // setHeadSelected(_lungCount > 0);
        // setChestSelected(_heartCount > 0);
        setLungSelectedCount(_lungCount);
        setHeartSelectedCount(_heartCount);
        setOrganList(_list);
        const _organs = organs;
        _organs.organs = _list;
        setOrgans(_organs)
        // props.onComplete('chest', _list)
        props.onComplete('chest', _list);
    }
    
    const setOrganSelectedActive = (mOrganList?: any) => {
        let _lungCount = 0;
        let _heartCount = 0;
        let _organList = mOrganList || organList;
        _organList.forEach((item: any) => {
            item.symptoms.forEach((v: any) => {
                let _selected = v.selected;
                if (item.type === 'lung') {
                    if (_selected) {
                        _lungCount++;
                    }
                } else if (item.type === 'heart') {
                    if (_selected) {
                        _heartCount++;
                    }
                }
            });
        });
        // setHeadSelected(_lungCount > 0);
        // setChestSelected(_heartCount > 0);
        setLungSelectedCount(_lungCount);
        setHeartSelectedCount(_heartCount);
    }

    const setOtherValue = (value: any) => {
        let _organs = organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                const symptoms = vvv.symptoms.map((vv: any) => {
                    if (activeOrgan === vvv.type && vv.code === '') {
                        let selected = !!value;
                        return {
                            code: '',
                            name: '其他',
                            value: value,
                            selected: selected,
                            organCode: vv.organCode
                        }
                    } else {
                        return vv;
                    }

                })
                return {
                    ...vvv,
                    symptoms
                }
            } else {
                return vvv;
            }

        })
        setOrgans(_organs)
        let _list = _organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        props.onComplete('chest', _list);
        return _list;
    }

    return (
        <div className={styles.ae_reporting}>
            <div className={styles.choose_symptom}>
                <div className={styles.content_area}>
                    <div className={styles.sympton_title}>ALK【胸部】常见风险症状：</div>
                    <div className={styles.sympton_content}>
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.active : styles.un_active}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.body_title}>
                <div className={styles.body_active} onClick={ () => { props.onBack() }}>
                    全部
                </div>
                <div className={styles.body_middle_active}>
                    胸部
                </div>
                <div className={styles.body_un_active}>{ organMap[activeOrgan] || '未选器官'}</div>
            </div>
            <div className={styles.area_body_container}>
                {/* 身体 */}
                <img className={styles.area_body} src={blue_body} alt="" />
                {/* 胸 */}
                <img className={styles.area_body_organ_heart} src={body_organ_heart} alt="" />
                {/* 心脏 */}
                <img className={styles.area_body_organ_lung} src={body_organ_lung} alt="" />
                {/* 其他标注 */}
                <div className={`${styles.area_base} ${styles.area_head} ${headSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { headSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={headSelected ? organ_lung_blue : organ_lung_purple} alt="" />
                        <div>肺部</div>
                        {
                            lungSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {lungSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    <img  className={styles.line_head} src={line_to_lung} alt="" />
                </div>
                <div className={`${styles.area_base} ${styles.area_chest} ${chestSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { chestSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={chestSelected ? organ_heart_blue : organ_heart_purple} alt="" />
                        <div>心脏</div>
                        {
                            heartSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {heartSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    <img  className={styles.line_chest} src={line_to_heart} alt="" />
                </div>
                <div onClick={() => { props.onBack() }} className={`${styles.area_base} ${styles.area_four_limbs} ${fourLimbsSelected ? styles.area_active : styles.area_in_active}`}>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={arrow_back} alt="" />
                        <div>返回</div>
                    </div>
                </div>
            </div>
            {/* <div className={styles.btns_wrap}>
                <div className={styles.btns_back}>
                    <img className={styles.bootom_top} src={bg_back} alt="" />
                    <div className={styles.text} onClick={() => { props.onBack() }}>返回上一步</div>
                </div>
                <div className={styles.btns_finish_go_on}>
                    <img className={styles.bootom_top} src={bg_finish_go_on} alt="" />
                    <div className={styles.text} onClick={() => { props.onComplete('chest', organList) }}>选择完成，继续评测</div>
                </div>
            </div> */}
            <Modal
                visible={visible}
                content={
                    <TextArea
                        placeholder='请输入内容'
                        value={value}
                        onChange={val => {
                            setValue(val)
                        }}
                    />
                }
                // closeOnMaskClick
                closeOnAction
                onClose={() => {
                    setOrganSelectedActive(setOtherValue(value));
                    setVisible(false)
                }}
                actions={[
                    {
                        key: 'confirm',
                        text: '确定',
                    },
                ]}
            >
            </Modal>
        </div>
    )
}

export default withRouter(Chest);